import { render } from "./FeaturedArticles.vue?vue&type=template&id=48400215&scoped=true"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js"

import "./FeaturedArticles.vue?vue&type=style&index=0&id=48400215&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48400215"]])

export default __exports__